import React from 'react';
import {
  HbrDropdown,
  HbrButton,
  HbrIcon,
} from '@harbor/elements-react-standalone';
import { useNavigate } from 'react-router-dom';
import { user, navOverview } from '@harbor/elements/icons';
import UserProfileSystemStatusSection from './UserProfileSystemStatusSection';
import UserProfileInfoSection from './UserProfileInfoSection';
import UserProfileAuthSection from './UserProfileAuthSection';

const userProfileStyles = {
  menu: {
    display: 'flex',
    flexDirection: 'column' as const,
    minWidth: 320,
    padding: 0,
    boxShadow: 'var(--hbr-shadow-xs)',
    borderRadius: 6,
    border: '2px solid var(--hbr-color-neutral-border)',
    background: 'var(--hbr-color-neutral-bg, #fff)',
  } as React.CSSProperties,
  divider: {
    borderTop: 'solid 1px var(--hbr-color-neutral-border-weak)',
  } as React.CSSProperties,
  labelBold: {
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'left' as const,
    lineHeight: '20px',
    padding: '0 12px',
  } as React.CSSProperties,
  profileLink: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 14,
    width: '100%',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 600,
    color: '#1a2332',
    textAlign: 'left' as const,
  } as React.CSSProperties,
  profileLinkPrefix: {
    flex: '0 0 20px',
    width: 20,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--hbr-color-neutral-icon, #7E868F)',
  } as React.CSSProperties,
};

const UserProfileLoggedIn: React.FC<{
  name: string | null;
  email: string | null;
  authProvider: 'salesforce' | 'cisco_sso' | null;
  hasSalesforceAccess: boolean;
  onConnectSalesforce: () => void;
  fullLogout: () => void;
}> = ({
        name,
        email,
        authProvider,
        hasSalesforceAccess,
        onConnectSalesforce,
        fullLogout,
      }) => {
  const navigate = useNavigate();

  // placement="bottom-end" right-aligns the panel with its trigger so it opens
  // inward from the right edge of the header instead of overflowing past it.
  return (
  <HbrDropdown slot="user-profile" hoist menu distance={12} placement="bottom-end">
    <HbrButton noPadding slot="trigger" data-testid="user-profile-trigger" caret>
      <HbrIcon asset={user} style={{ fontSize: 24 }} slot="prefix" />
      <div style={userProfileStyles.labelBold}>{name || 'Profile'}</div>
    </HbrButton>

    <div style={userProfileStyles.menu} data-testid="user-profile-popover">
      <UserProfileInfoSection email={email} logout={fullLogout} />
      <div style={userProfileStyles.divider} />
      <button
        type="button"
        style={userProfileStyles.profileLink}
        onClick={() => navigate('/portal?view=profile')}
      >
        <div style={userProfileStyles.profileLinkPrefix}>
          <HbrIcon asset={navOverview} style={{ fontSize: 20 }} />
        </div>
        View Profile
      </button>
      <div style={userProfileStyles.divider} />
      <UserProfileAuthSection
        authProvider={authProvider}
        hasSalesforceAccess={hasSalesforceAccess}
        onConnectSalesforce={onConnectSalesforce}
      />
      <div style={userProfileStyles.divider} />
      <UserProfileSystemStatusSection />
    </div>
  </HbrDropdown>
  );
};

export default UserProfileLoggedIn;